import { registerPlugin, Capacitor } from '@capacitor/core';

const WidgetSync = registerPlugin('WidgetSync');

/**
 * Push the latest rates and widget preferences into the home-screen widget cache.
 * Silently no-ops on web or if the native bridge is missing.
 * @param {Array<{code: string, title: string, sell: string, buy?: string, isGold: boolean, emoji: string}>} rates
 * @param {string} time
 */
export const updateWidgetRates = async (rates, time) => {
  try {
    if (!Capacitor.isNativePlatform() || !rates || rates.length === 0) return;
    const selectedCurrency = localStorage.getItem('selectedWidgetCurrency') || 'USD';
    const selectedGold = localStorage.getItem('selectedWidgetGold') || '18AYAR';

    await WidgetSync.updateWidget({
      rates,
      time: time || '',
      selectedCurrency,
      selectedGold,
    });
  } catch (e) {
    // Graceful fallback on web / missing plugin
  }
};

export const getSelectedWidgetCurrency = () => {
  return (localStorage.getItem('selectedWidgetCurrency') || 'USD').toUpperCase();
};

export const getSelectedWidgetGold = () => {
  return (localStorage.getItem('selectedWidgetGold') || '18AYAR').toUpperCase();
};

/**
 * Update the user's selected currency/gold for the iOS widgets and reload timelines.
 * @param {string} currency - currency code (e.g. 'USD', 'EUR', 'TRY')
 * @param {string} gold - gold code (e.g. '18AYAR', 'SEKKEH', 'NIM')
 */
export const setWidgetPreferences = async (currency, gold) => {
  try {
    if (currency) localStorage.setItem('selectedWidgetCurrency', currency.toUpperCase());
    if (gold) localStorage.setItem('selectedWidgetGold', gold.toUpperCase());

    if (!Capacitor.isNativePlatform()) return;
    await WidgetSync.setWidgetPreferences({
      currency: (currency || '').toUpperCase(),
      gold: (gold || '').toUpperCase(),
    });
  } catch (e) {
    // Graceful fallback
  }
};
